import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../App';
import OverviewTab from '../components/MetaAds/OverviewTab';
import CampaignsTab from '../components/MetaAds/CampaignsTab';
import AdsTab from '../components/MetaAds/AdsTab';
import LeadsTab from '../components/MetaAds/LeadsTab';
import ConnectionTab from '../components/MetaAds/ConnectionTab';

const MetaAds = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState({ connected: false });
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), type === 'error' ? 7000 : 3500);
  };

  const checkConnection = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/meta/status', {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      setConnectionStatus(res.data);
      if (!res.data.connected) {
        setActiveTab('connection');
      }
    } catch (err) {
      console.error(err);
      showToast('Bağlantı durumu kontrol edilemedi', 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    checkConnection();
  }, []);

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: '📊' },
    { id: 'campaigns', label: 'Kampanyalar', icon: '📢' },
    { id: 'ads', label: 'Reklamlar', icon: '🖼️' },
    { id: 'leads', label: 'Leadler', icon: '🎯' },
    { id: 'connection', label: 'Bağlantı', icon: '🔌' }
  ];

  return (
    <div className="meta-panel-page" style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
      {toast && (
        <div className={`meta-toast ${toast.type}`}>
          {toast.message}
        </div>
      )}

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', margin: '0 0 4px 0', color: 'var(--text)' }}>
            📘 Meta Ads Paneli
          </h1>
          <p style={{ margin: 0, color: 'var(--text-muted)' }}>Facebook ve Instagram reklamlarınızı CRM'den yönetin</p>
        </div>
        <div>
          {connectionStatus.connected && (
            <span className="badge badge-success" style={{ padding: '6px 12px', gap: '8px' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></span>
              Bağlı ({connectionStatus.account_name || connectionStatus.ad_account_id})
            </span>
          )}
        </div>
      </div>

      <div className="meta-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            disabled={!connectionStatus.connected && tab.id !== 'connection'}
            className={`meta-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="meta-content">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>Yükleniyor...</div>
        ) : (
          <>
            {activeTab === 'overview' && <OverviewTab showToast={showToast} />}
            {activeTab === 'campaigns' && <CampaignsTab showToast={showToast} />}
            {activeTab === 'ads' && <AdsTab showToast={showToast} />}
            {activeTab === 'leads' && <LeadsTab showToast={showToast} />}
            {activeTab === 'connection' && (
              <ConnectionTab
                connectionStatus={connectionStatus}
                onStatusChange={checkConnection}
                showToast={showToast}
              />
            )}
          </>
        )}
      </div>

      <style>{`
        .meta-toast {
          position: fixed; bottom: 24px; right: 24px; z-index: 9999;
          padding: 14px 20px; border-radius: 12px; font-size: 14px; font-weight: 600;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
          animation: toastIn 0.3s ease;
        }
        .meta-toast.success { background: #10B981; color: white; }
        .meta-toast.error { background: #EF4444; color: white; }
        .meta-toast.warning { background: #F59E0B; color: white; }
        @keyframes toastIn { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }

        .meta-tabs {
          display: flex;
          gap: 6px;
          margin-bottom: 24px;
          border-bottom: 1px solid var(--border);
          padding-bottom: 0;
        }

        .meta-tab-btn {
          padding: 10px 16px;
          border: none;
          background: transparent;
          color: var(--text-muted);
          font-weight: 500;
          font-size: 14px;
          border-radius: 10px 10px 0 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: var(--transition-fast);
          border-bottom: 2px solid transparent;
          margin-bottom: -1px;
          font-family: var(--font-family);
        }

        .meta-tab-btn:hover:not(:disabled) {
          color: var(--text);
          background: rgba(255,255,255,0.03);
        }

        .meta-tab-btn.active {
          color: var(--primary);
          border-bottom-color: var(--primary);
          background: rgba(var(--primary-rgb), 0.05);
        }

        .meta-tab-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default MetaAds;
